import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { CartProvider } from './context/cart-context';
import { ToasterProvider } from './context/toaster-context';
import { GeolocationProvider } from './context/geolocation-context';
import { PaymentStatusProvider } from './context/payment-status-context';
import { AuthProvider } from './context/auth-context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter basename='/'>
    <AuthProvider>  
      <CartProvider>
        <ToasterProvider>
          <GeolocationProvider>
            <PaymentStatusProvider>
              <App />
            </PaymentStatusProvider>
          </GeolocationProvider>
        </ToasterProvider>
      </CartProvider>
    </AuthProvider>
  </BrowserRouter>
);